import { useEffect, useState } from 'react';
import { isMissingDeliveryAddress, PublicDeliveryInfo } from '../types/store';
import PublicDeliveryModal from './PublicDeliveryModal';

type PublicNavbarProps = {
  deliveryInfo: PublicDeliveryInfo;
  cartUnits: number;
  onOpenCart: () => void;
  onDeliveryChange: (delivery: PublicDeliveryInfo) => void;
  requireAddress?: boolean;
};

export default function PublicNavbar({
  deliveryInfo,
  cartUnits,
  onOpenCart,
  onDeliveryChange,
  requireAddress = false,
}: PublicNavbarProps) {
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);

  const missingAddress = isMissingDeliveryAddress(deliveryInfo.address);
  const isAddressLocked = requireAddress && missingAddress;

  useEffect(() => {
    if (isAddressLocked) {
      setIsAddressModalOpen(true);
    }
  }, [isAddressLocked]);

  const openAddressModal = () => {
    setIsAddressModalOpen(true);
  };

  const closeAddressModal = () => {
    if (isAddressLocked) {
      return;
    }
    setIsAddressModalOpen(false);
  };

  const handleDeliverySubmit = (delivery: PublicDeliveryInfo) => {
    onDeliveryChange(delivery);
    setIsAddressModalOpen(false);
  };

  return (
    <>
      <header className="public-navbar public-navbar-fixed">
        <div className="public-navbar-inner">
          <div className="public-address">
            <span className="subtitle">Direccion de entrega</span>
            <div className="public-address-row">
              <strong>
                {missingAddress ? 'Agrega tu direccion de entrega' : deliveryInfo.address}
              </strong>
              {!isAddressLocked ? (
                <button
                  type="button"
                  className="public-address-edit"
                  aria-label="Editar direccion de entrega"
                  onClick={openAddressModal}
                >
                  ✏️
                </button>
              ) : null}
            </div>
          </div>

          <button
            type="button"
            className="public-cart-button"
            aria-label="Carrito de compras"
            onClick={onOpenCart}
          >
            🛒{' '}
            {cartUnits > 0 ? (
              <span className="cart-badge">{cartUnits}</span>
            ) : null}
          </button>
        </div>
      </header>

      <PublicDeliveryModal
        isOpen={isAddressModalOpen}
        deliveryInfo={deliveryInfo}
        onClose={closeAddressModal}
        onSubmit={handleDeliverySubmit}
        isLocked={isAddressLocked}
      />
    </>
  );
}
